import { render, staticRenderFns } from "./DriversStatusSettings.vue?vue&type=template&id=4c4a1ffe&scoped=true"
import script from "./DriversStatusSettings.vue?vue&type=script&lang=js"
export * from "./DriversStatusSettings.vue?vue&type=script&lang=js"
import style0 from "./DriversStatusSettings.vue?vue&type=style&index=0&id=4c4a1ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4a1ffe",
  null
  
)

export default component.exports